import { useState, useEffect } from "react";

const useChangePenaltiesByReasonForPenalize = ({
    reasonForPenalizeId,
    penaltyTypeList,
    changePenalizeId
}) => {
    //#region States
    const [penaltyTypeListFiltered, setPenaltyTypeListFiltered] = useState([]);
    //#endregion
    //#region Effects
    useEffect(() => {
        setPenaltyTypeListFiltered(penaltyTypeList.filter(item => item.reasonForPenalizeId === reasonForPenalizeId));
    }, [reasonForPenalizeId]);
    useEffect(() => {
        if (penaltyTypeListFiltered.length === 0) {
            changePenalizeId(0);
            return;
        }
        if (penaltyTypeListFiltered.length !== 1) return;
        changePenalizeId(penaltyTypeListFiltered[0].id);
    }, [penaltyTypeListFiltered]);
    //#endregion
    return {
        penaltyTypeListFiltered
    };
}

export default useChangePenaltiesByReasonForPenalize;